/**
 * Save (de)compression + base64 helpers. Snapshots are big but hugely repetitive
 * JSON (thousands of near-identical resource-node records), so gzip shrinks them
 * ~10x. Files download as .json.gz; localStorage holds base64 (it is string-only).
 */

/** gzip a string to bytes. */
export async function gzip(str: string): Promise<Uint8Array> {
  const stream = new Blob([str]).stream().pipeThrough(new CompressionStream("gzip"));
  return new Uint8Array(await new Response(stream).arrayBuffer());
}

/** Inflate gzip bytes back to a string. */
export async function gunzip(bytes: Uint8Array): Promise<string> {
  const stream = new Blob([bytes as BlobPart]).stream().pipeThrough(new DecompressionStream("gzip"));
  return await new Response(stream).text();
}

export function bytesToB64(bytes: Uint8Array): string {
  let s = "";
  for (let i = 0; i < bytes.length; i += 0x8000) s += String.fromCharCode(...bytes.subarray(i, i + 0x8000));
  return btoa(s);
}

export function b64ToBytes(b64: string): Uint8Array {
  const s = atob(b64);
  const a = new Uint8Array(s.length);
  for (let i = 0; i < s.length; i++) a[i] = s.charCodeAt(i);
  return a;
}

/** Normalize any save input (gzip bytes, or plain-JSON text) to a JSON string. */
export async function readSave(bytes: Uint8Array): Promise<string> {
  if (bytes[0] === 0x1f && bytes[1] === 0x8b) return gunzip(bytes); // gzip magic
  return new TextDecoder().decode(bytes); // legacy / hand-edited plain JSON
}
